import { BigHeader } from '@narvar/nth-header';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Container, Row, Column } from '@narvar/nth-grid';
import Instruction, { InstructionList } from './Instruction';
import Confirmation from './Confirmation';
import NarvarFooter from '../NarvarFooter';
import { getUrlInfo } from '../../lib/url';

const mapStateToProps = ({
  language,
  pickupAddon: { pickupDate, form: { pickupTime } } = {},
  retailerSettings: {
    branding: { brand_call_to_action: brandCtaColor } = {},
    name: retailerName,
  } = {},
}) => ({
  language,
  retailerName,
  pickupDate,
  brandCtaColor,
  pickupTime,
});

const PickupSuccess = ({ language, retailerName, pickupDate, pickupTime }) => (
  <Container>
    <Row style={{ marginTop: '4rem' }}>
      <Column xl-columns={8} xl-column-offset={2} lg-columns={10} lg-column-offset={1}>
        <Row style={{ textAlign: 'center' }}>
          <BigHeader s={{ margin: '0' }}>
            {language['returns.pickups_page.success.header']}
          </BigHeader>
        </Row>

        <Row>
          <Confirmation />
        </Row>

        <Row style={{ margin: '0 0.25rem' }}>
          <p style={{ fontFamily: 'inherit', fontWeight: 700, textAlign: 'center' }}>
            {language['returns.pickups_page.instructions.header']}
          </p>
          <InstructionList>
            <Instruction
              number={1}
              button
              onClick={() => {
                const { params: { return_id: returnId } = {} } = getUrlInfo();
                window.open(`/returns/${retailerName}/viewlabel?return_id=${returnId}`, '_blank');
              }}
            />
            <Instruction number={2} />
            <Instruction number={3} date={pickupDate} pickupTime={pickupTime} />
          </InstructionList>
        </Row>

        <Row style={{ marginTop: '6rem' }}>
          <NarvarFooter />
        </Row>
      </Column>
    </Row>
  </Container>
);

PickupSuccess.defaultProps = {
  brandCtaColor: '#000000',
  pickupTime: '',
};

PickupSuccess.propTypes = {
  language: PropTypes.object.isRequired,
  retailerName: PropTypes.string.isRequired,
  pickupDate: PropTypes.string.isRequired,
  pickupTime: PropTypes.string,
  brandCtaColor: PropTypes.string,
};

export default connect(mapStateToProps)(PickupSuccess);
